import uniqueId from '@form-create/utils/lib/unique';
import { makeRequiredRule } from '../../utils';
var label = '附件';
var name = 'upload';
export default {
  icon: 'iconfont iconfujian1',
  label: label,
  name: name,
  rule: function rule() {
    return {
      type: name,
      field: uniqueId(),
      title: label,
      info: '',
      props: {
        action: '',
        onSuccess: function onSuccess(res, file) {
          file.url = res.data.url;
        }
      }
    };
  },
  props: function props() {
    return [makeRequiredRule()];
  },
  basic: function basic() {}
};